import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import FoldersListView from "./folders-list.html";


angular.module("folders", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('folders', {
                url: "/folders",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('folders.list', {
                url: "/list/:entity_type/:entity_type_id/:is_public",
                controller: "FoldersListCtrl",
                template: FoldersListView,
                cache: false,
                resolve: {
                    entity_type: ['$stateParams', function ($stateParams) {
                        if (angular.isDefined($stateParams.entity_type) && $stateParams.entity_type != "") {
                            return $stateParams.entity_type;
                        }
                        return null;
                    }],
                    entity_type_id: ['$stateParams', function ($stateParams) {
                        if (angular.isDefined($stateParams.entity_type_id) && $stateParams.entity_type_id != "") {
                            return $stateParams.entity_type_id;
                        }
                        return null;
                    }],
                    is_public: ['$stateParams', function ($stateParams) {
                        if (angular.isDefined($stateParams.is_public) && $stateParams.is_public != "") {
                            return $stateParams.is_public;
                        }
                        return false;
                    }]
                },
                data: { pageTitle: 'Carpetas' },
                //requiredPermission: ["FILES_READ"]
            })
        ;
    }])
;